import { useState, useEffect } from 'react'
import { Input } from '@/components/ui/input'

interface CalculatorInputProps {
  label: string
  value: number | string
  onChange: (value: number) => void
  prefix?: string
  suffix?: string
  min?: number
  max?: number
  step?: number
  tooltip?: string
}

export function CalculatorInput({ label, value, onChange, prefix, suffix, tooltip }: CalculatorInputProps) {
  const [inputValue, setInputValue] = useState(String(value))

  useEffect(() => {
    setInputValue(String(value))
  }, [value])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value

    if (raw === '') {
      setInputValue('')
      onChange(0)
      return
    }

    if (/^-?\d*\.?\d*$/.test(raw)) {
      setInputValue(raw)
      const num = parseFloat(raw)
      if (!isNaN(num)) {
        onChange(num)
      }
    }
  }

  const handleBlur = () => {
    const num = parseFloat(inputValue) || 0
    setInputValue(String(num))
    onChange(num)
  }

  return (
    <div className="space-y-1.5">
      <label className="flex items-center gap-1.5 text-sm font-medium">
        {label}
        {tooltip && (
          <span className="text-muted-foreground cursor-help" title={tooltip}>
            i
          </span>
        )}
      </label>
      <div className="relative flex items-center">
        {prefix && <span className="text-muted-foreground absolute left-3 text-sm">{prefix}</span>}
        <Input
          type="text"
          inputMode="decimal"
          value={inputValue}
          onChange={handleChange}
          onBlur={handleBlur}
          className={`${prefix ? 'pl-7' : ''} ${suffix ? 'pr-12' : ''}`}
        />
        {suffix && <span className="text-muted-foreground absolute right-3 text-sm">{suffix}</span>}
      </div>
    </div>
  )
}
